import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import es from 'react-phone-input-2/lang/es.json'
import { FormHelperText, FormControl } from '@material-ui/core';


const PhoneInputWithMaterialUI = (props) => {
    // const classes = useStyles();
    return (
        <FormControl 
            style={props.margin ? { margin: props.margin } : { marginTop: '1%', paddingRight: 16 }}>
            <PhoneInput
                inputProps={{
                    name:props.name,
                }}
                onlyCountries={props.onlyCountries}
                localization={es}
                value={props.value}  // Valor 
                country={props.inicialCountry} // "País default"
                excludeCountries={props.excludeCountries} // Para numero extranjero excluimos GT
                enableSearch={props.enableSearch} // Habilitar búsqueda dentro de la lista
                showDropdown={props.showDropdown} // Mostrar lista de paises al cargar componente
                specialLabel={props.label}
                searchPlaceholder={"Buscar"} // Texto del input de búsqueda
                onChange={props.handleChange}  // Evento
                // Ya esta adaptado para ser utilizado con MUI
                inputStyle={props.useStyle ? {
                    width: '100%',
                    padding: '12.5px 14px 12.5px 58px',
                    margin: '10px 0',
                    border: 'none',
                    borderBottom: '1px solid #949494',
                    borderRadius: '0px'
                }: {
                    width: '100%',
                    border: props.isError ? '1px solid #f44336' : '1px solid #0000003b',
                }}
                disabled={props.disabled}
            />
            {props.isError ? (
                <FormHelperText className="Mui-error" id="component-error-text">
                    {props.errorMessages} 
                </FormHelperText>
            ) :
                <FormHelperText id="component-helper-text">
                    {props.infoMessages} 
                </FormHelperText>
            }
        </FormControl>
    );
};

export default PhoneInputWithMaterialUI;